
function addItemskinbalmv401() {
    const selectedOption = document.querySelector('.pack-option.selected');

    if (!selectedOption) {
        alert("Please select a pack first");
        return;
    }

    const idValue = selectedOption.id;
    let findPack = 0;

    switch (idValue) {
        case "1pack": findPack = 42838410264638; break;
        case "2pack": findPack = 42838410821694; break;
        case "4pack": findPack = 42838410985534; break;
    }

    if (!findPack) return;

    fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            items: [{
                id: findPack,
                quantity: 1,
                properties: {
                    _unique_id: Date.now().toString()
                }
            }]
        })
    })
    .then(r => {
        if (!r.ok) throw new Error("Cart add failed");
        return r.json();
    })
    .then(() => fetch('/cart'))
    .then(res => res.text())
    .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newCartContents = doc.querySelector('#CartDrawer');

        if (newCartContents && document.querySelector('#CartDrawer')) {
            document.querySelector('#CartDrawer').innerHTML = newCartContents.innerHTML;
        }

        document.querySelector('cart-drawer')?.classList.add('active');
    })
    .catch(err => console.error(err));
}




